function setConsent(consent) {
	const consentMode = {
		functionality_storage: consent.necessary ? "granted" : "denied",
		security_storage: consent.necessary ? "granted" : "denied",
		ad_storage: consent.marketing ? "granted" : "denied",
		analytics_storage: consent.analytics ? "granted" : "denied",
		personalization_storage: consent.preferences ? "granted" : "denied",
	};
	// eslint-disable-next-line no-undef
	gtag("consent", "update", consentMode);
	localStorage.setItem("consentMode", JSON.stringify(consentMode));
	const daysToExpiry = 60;
	const expiryDate = Date.now() + daysToExpiry * 24 * 60 * 60 * 1000; // Days * Hours * Minutes * Seconds * Milliseconds
	localStorage.setItem("consentModeExpiry", JSON.stringify(expiryDate));
}

function acceptAll() {
	setConsent({
		necessary: true,
		analytics: true,
		preferences: true,
		marketing: true,
	});
}

function acceptSome() {
	setConsent({
		necessary: true,
		analytics: document.getElementById("consent-analytics").checked,
		preferences: document.getElementById("consent-preferences").checked,
		marketing: document.getElementById("consent-marketing").checked,
	});
}

function rejectAll() {
	setConsent({
		necessary: true,
		analytics: false,
		preferences: false,
		marketing: false,
	});
}

if (localStorage.getItem("consentMode") === null) {
	const actions = [
		{
			label: "Accept All",
			fn: acceptAll,
			htmlClass: "btn btn-success btn-small",
		},
		{
			label: "Accept Selection",
			fn: acceptSome,
			htmlClass: "btn btn-secondary btn-small",
		},
		{
			label: "Reject Non-essential",
			fn: rejectAll,
			htmlClass: "btn btn-secondary btn-small",
		},
	];

	const txtHeader = "Cookie settings";
	const txtBody =
		"We use cookies to provide you with the best possible experience. They also allow us to analyze user behavior in order to constantly improve the website for you.";
	const cookieConsentOptions = ["Necessary", "Analytics", "Preferences", "Marketing"];
	const privacyPolicyLink = "/pages/privacy-policy";
	const privacyPolicyHTML = `To read more about how we use cookies please see our <a href="${privacyPolicyLink}">Privacy Policy<a>.`;
	const htmlBody = `
      <div>${txtBody}</div>
      <div class="cookie-consent-options">
        ${cookieConsentOptions
					.map(
						(cookieType) =>
							`<label><input id="consent-${cookieType.toLowerCase()}" type="checkbox" value="${cookieType}" checked ${
								cookieType === "Necessary" ? "disabled" : ""
							}>${cookieType}</label>`
					)
					.join("")}
      </div>
      <small>${privacyPolicyHTML}</small>`;

	showModal({
		txtHeader,
		htmlBody,
		actions,
		wrapperClass: "cookie-modal",
		dontAllowDismiss: true
	});
}
